import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import OurTeamContent from '../components/OurTeamContent';
import Footer from '../components/Footer';

const OurTeam = () => {
  return (
    <div className="OurTeam">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero
          image="/assets/images/our-team.jpeg"
          heightClass="min-h-[80vh] sm:min-h-[90vh] lg:min-h-[110vh]"
          fit="cover"
          backgroundColor="#f5f0eb"
        />
        <OurTeamContent />
        <Footer />
      </div>
    </div>
  );
};

export default OurTeam;


